<app-progress-card [module]="modulePackage" [hasMenu]="true" [url]="url" [queryParam]="routerParams" [type]="'package'"></app-progress-card>